import { Transform } from 'class-transformer';
import { IsEmail, IsNotEmpty, IsUUID } from 'class-validator';
import { DateFilter } from '../../interfaces/filters/date.filter';
import { PaginationFilter } from '../../interfaces/filters/pagination.filter';
import { arrayOrStringToArray } from '../../types-transformers/array-transformers';

export class EventTicketsFilter implements PaginationFilter, DateFilter {
	@Transform(arrayOrStringToArray)
	orderIds?: string[];

	eventId?: string;
	eventInstanceDate?: Date;

	periodFrom?: Date;
	periodTo?: Date;

	page?: number | null;
	pageSize?: number | null;
}


export class EventTicketsPublicFilter implements PaginationFilter, DateFilter {
	// required

	@IsNotEmpty()
	@IsEmail()
	email: string;

	@IsNotEmpty()
	@IsUUID()
	eventId: string;

	@IsNotEmpty()
	eventInstanceDate: Date;

	// optional

	@Transform(arrayOrStringToArray)
	orderIds?: string[];

	periodFrom?: Date;
	periodTo?: Date;

	pageSize?: number | null;
	page?: number | null;
}
